import { useEffect, useState, useRef } from "react";
import { InteractionManager, AppState } from "react-native";
import analytics from "@services/analytics";
import invokeAppRating from "@utils/invokeInAppRating";
import { IN_APP_RATING_SHOWN } from "@constants/analyticsEvents";

const useInAppRating = () => {
  const [state, setState] = useState(false);
  const ratingModalShownTime = useRef(0);

  const handleAppState = (state) => {
    if (state === "background") {
      ratingModalShownTime.current = new Date().getTime();
    } else if (state === "active" && ratingModalShownTime.current !== 0) {
      const lag = new Date().getTime() - ratingModalShownTime.current;
      if (lag > 500) {
        analytics.trackEvent(IN_APP_RATING_SHOWN);
      }
    }
  };

  useEffect(() => {
    if (state) {
      InteractionManager.runAfterInteractions(() => {
        AppState.addEventListener("change", handleAppState);
        invokeAppRating(handleAppState);
        setState(false);
      });
    }
  }, [state]);
  return setState;
};

export default useInAppRating;
